import {connect} from 'react-redux';
import classNames from 'classnames';

import Portal from '../../general/components/Portal';

import Content from './Content';
import FavouritesArea from './FavouritesArea';

const className = panelOpen => classNames('container-fluid', {
    'panel-open': panelOpen === 'config-header',
});

const ContentArea = ({panelOpen}) => (
    <Portal container="content-area">
        <div className={className(panelOpen)}>
            <div className="row">
                <Content />
                <FavouritesArea />
            </div>
        </div>
    </Portal>
);

const mapStateToProps = ({panelOpen}) => ({panelOpen});

export default connect(mapStateToProps)(ContentArea);
